module.exports = __webpack_public_path__ + "img/privilege7.e27dcf1e.png";